<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="cutTab">
      <el-tab-pane label="分销商用户" name="1">
        <div>
          <el-input v-model="nameMoile" style="width: 213px;" placeholder="请输入昵称/姓名/手机号" size="small" clearable></el-input>
          <el-button type="primary" size="small" style="margin-left:10px;" @click="handleClick('querySubmit')">查询</el-button>
          <el-button type="primary" size="small" @click="handleClick('add')"><i class="el-icon-plus"></i>添加</el-button>
        </div>
        <div style="margin-top: 15px;">
          <el-table :data="tableData" border>
            <el-table-column prop="userId" label="用户ID" width="60"></el-table-column>
            <!-- <el-table-column prop="avatarurl" label="头像">
              <template slot-scope="scope">
                <img :src="scope.row.avatarurl" width="140px" v-if="scope.row.avatarurl" />
                <span v-if="scope.row.avatarurl == null || scope.row.avatarurl == '' || scope.row.avatarurl == undefined">
                  {{ '暂无图片' }}
                </span>
              </template>
</el-table-column> -->
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="totalCommission" label="累积佣金"></el-table-column>
            <el-table-column prop="withdrawCommission" label="可提现佣金"></el-table-column>
            <el-table-column prop="referrerName" label="推荐人"></el-table-column>
            <el-table-column prop="userId" label="下级用户"></el-table-column>
            <el-table-column prop="createTime" label="成为时间"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick('orderForGoods', scope.row)" type="text" size="small">订单</el-button> -->
                <!-- <el-button @click="handleClick('withdrawal', scope.row)" type="text" size="small">提现</el-button> -->
                <el-button @click="handleClick('subordinate', scope.row)" type="text" size="small">下级</el-button>
                <el-button @click="handleClick('modify', scope.row)" type="text" size="small">修改</el-button>
                <el-button @click="handleClick('del', scope.row)" type="text" size="small" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
              :page-sizes="[1, 5, 10, 20]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo.total">
            </el-pagination>
          </div>
        </div>

        <!-- 新增 -->
        <el-dialog title="新增" :visible.sync="diaLogVisibleAdd" width="30%" v-if="diaLogVisibleAdd" :destroy-on-close="true"
          :before-close="handleClose">
          <div>
            <el-form ref="form" :model="form" label-width="80px" :rules="formRules">
              <el-form-item label="选择用户">
                <el-button type="primary" @click="handleClick('selectVIP')"><i class="el-icon-plus"></i>选择会员</el-button>
              </el-form-item>
              <el-form-item label="等级">
                <el-select v-model="form.agentGradeId" clearable placeholder="请选择等级" size="small">
                  <el-option v-for="item in agentGradeIdOption" :key="item.gradeId" :value="item.gradeId" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="form.name" size="small"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="form.mobile" size="small"></el-input>
              </el-form-item>
              <el-form-item label="推荐人ID" prop="referrerId">
                <el-input v-model="form.referrerId" size="small"></el-input>
                <div style="color:#ccc;">如果没有上级则设置为0</div>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClick('close')" size="small">取 消</el-button>
            <el-button type="primary" @click="handleClick('confim')" size="small">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 修改分销商列表 -->
        <el-dialog title="修改" :visible.sync="diaLogVisibleModify" v-if="diaLogVisibleModify" width="500px">
          <el-form :model="form" :rules="formRules" label-position="right" label-width="80px">
            <!-- <el-form-item label="微信昵称">
              <el-input v-model="form.nickname" disabled size="small"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="头像">
              <img :src="form.avatarurl" alt="" width="100px" />
            </el-form-item> -->
            <el-form-item label="姓名">
              <el-input v-model="form.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="form.mobile" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="推荐人ID">
              <el-input v-model="form.referrerId" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item label="推荐人昵称">
              <el-input v-model="form.referrerName" disabled size="small"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClick('closeModify')" size="small">取 消</el-button>
            <el-button type="primary" @click="handleClick('confimModify')" size="small">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 选择用户 -->
        <el-dialog title="选择会员" :visible.sync="diaLogVisibleSelect" v-if="diaLogVisibleSelect">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="昵称">
              <el-input v-model="formInline.nickName" placeholder="请输入昵称" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="formInline.mobile" placeholder="请输入手机号" size="small" clearable></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleClick('submit')" size="small">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="userTable" border @selection-change="handleSelectionChange" ref="accountRef">
            <el-table-column type="selection" width="55">

            </el-table-column>
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="createTime" label="注册时间"></el-table-column>
          </el-table>
          <div style="margin-top: 20px;">
            <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="queryInfo2.pagenum"
              :page-sizes="[1, 5, 10, 20]" :page-size="queryInfo2.pagesize" layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo2.total">
            </el-pagination>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClick('closeVIP')" size="small">取 消</el-button>
            <el-button type="primary" @click="handleClick('confimVIP')" size="small">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 下级列表 -->
        <el-dialog title="下级用户" :visible.sync="diaLogVisibleSubordinate" v-if="diaLogVisibleSubordinate">
          <div style="margin-bottom:10px;">
            <el-radio-group v-model="level" @input="levelInput">
              <el-radio-button label="1">一级</el-radio-button>
              <el-radio-button label="2">二级</el-radio-button>
              <el-radio-button label="3">三级</el-radio-button>
            </el-radio-group>
          </div>
          <div style="margin-bottom:10px;">
            <el-table :data="tableSubordinate" border>
              <el-table-column prop="userID" label="用户ID"></el-table-column>
              <el-table-column prop="avatarurl" label="头像"></el-table-column>
              <el-table-column prop="name" label="微信昵称"></el-table-column>
              <el-table-column prop="mobile" label="手机号"></el-table-column>
              <el-table-column prop="createTime" label="加入时间"></el-table-column>
            </el-table>
          </div>
          <div style="margin-bottom:50px;">
            <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="queryInfo3.pagenum"
              :page-sizes="[1, 5, 10, 20]" :page-size="queryInfo3.pagesize" layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo3.total">
            </el-pagination>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="分销商等级" name="2">
        <el-tabs v-model="activeName2" type="card">
          <el-tab-pane label="套餐A等级设置" name="1">
            <div style="margin-bottom: 15px;">
              <el-select v-model="typeGrade" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in typeGradeOption" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </div>
            <el-table border :data="tableGeadeData" :loading="loading">
              <el-table-column prop="name" label="等级名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="commissionRate" label="佣金比例（%）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.commissionRate" size="small" @change="inputProportion($event, 'commissionRate', scope.$index)">
                    <i slot="suffix" style="font-style:normal;margin: 5px;display: inline-block;">%</i>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="people" label="成交人" width="260px">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.people" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="成交单" width="260px" v-if="typeGrade == '10'">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="成交人金额（元）" width="260px" v-if="typeGrade == '20'">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="peerLevelRate" label="平级奖（%）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.peerLevelRate" size="small" @change="inputProportion($event, 'peerLevelRate', scope.$index)">
                    <i slot="suffix" style="font-style:normal;margin: 5px;display: inline-block;">%</i>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" size="small"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;position:fixed;bottom: 50px;left:53%;">
              <el-button type="primary" size="small" @click="handleClick('save')">保存</el-button>
            </div>
            <!-- 添加等级 -->
            <el-dialog title="添加等级" :visible.sync="diaLogVisibleAddGrade" width="30%">
              <el-form ref="formGrade" :model="formGrade" label-width="80px">
                <el-form-item label="等级名称" prop="name">
                  <el-input v-model="formGrade.name" placeholder="请输入等级名称" size="small"></el-input>
                </el-form-item>
                <el-form-item label="等级权重" prop="name">
                  <el-input v-model="formGrade.name" placeholder="请输入等级权重" size="small"></el-input>
                </el-form-item>
                <el-form-item>
                  <div style="color:#ccc">权重越大，等级越高</div>
                </el-form-item>
                <el-form-item label="一级上调" prop="name">
                  <el-input-number v-model="num" controls-position="right" size="small" :min="1" :max="10"></el-input-number>
                </el-form-item>
                <el-form-item>
                  <div style="color:#ccc">在默认分佣比列上上调如果原来是5%，这里上调3%，那么一级拿8%佣金</div>
                </el-form-item>
                <el-form-item label="自动升级">
                  <el-radio-group v-model="radio">
                    <el-radio :label="3">允许自动升级</el-radio>
                    <el-radio :label="6">禁止自动升级</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="升级条件">
                  <el-radio-group v-model="radio">
                    <el-radio :label="3">满足以下所有条件</el-radio>
                    <el-radio :label="6">满足以下任意条件</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="checked">累计佣金</el-checkbox>
                  <el-input disabled style="width: 213px;"></el-input>元
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="checked">直推分销商</el-checkbox>
                  <el-input disabled style="width: 213px;"></el-input>元
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handleClick('addGradeClose')" size="small">取 消</el-button>
                <el-button type="primary" @click="handleClick('addGradeConfim')" size="small">确 定</el-button>
              </span>
            </el-dialog>

            <!-- 等级编辑 -->
            <el-dialog title="等级编辑" :visible.sync="diaLogVisibleView">
              <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="等级名称" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handleClick('viewClose')" size="small">取 消</el-button>
                <el-button type="primary" @click="handleClick('viewConfim')" size="small">确 定</el-button>
              </span>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane label="套餐B等级设置" name="2">
            <!-- <div style="margin-bottom: 15px;">
              <el-select v-model="list_planB" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in typeGradeOption" :key="item.value" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </div> -->
            <el-tabs v-model="activeName4" type="card" @tab-click="listPlanB">
              <el-tab-pane label="1.0" name="1">
                <el-table border :data="list_planB" :loading="loading">
                  <el-table-column prop="gradeId" label="等级ID">
                  </el-table-column>
                  <el-table-column prop="name" label="等级名称">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="commissionRate" label="佣金比例（%）">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.commissionRate" size="small">
                        <i slot="suffix" style="font-style:normal;margin: 5px;display: inline-block;">%</i>
                      </el-input>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="
              " label="成交额" width="260px" v-if="typeGrade == '10'">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.upgradeConditions" size="small"></el-input>
                </template>
              </el-table-column> -->
                  <el-table-column prop="upgradeConditions" label="成交金额（元）" width="260px">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.upgradeConditions" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="peerLevelRate" label="平级奖（%）">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.peerLevelRate" size="small">
                        <i slot="suffix" style="font-style:normal;margin: 5px;display: inline-block;">%</i>
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.remark" size="small"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="2.0" name="2">
                <el-table border :data="list_planB" :loading="loading">
                  <el-table-column prop="gradeId" label="等级ID">
                  </el-table-column>
                  <el-table-column prop="name" label="等级名称">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="commissionRate" label="佣金比例（%）">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.commissionRate" size="small">
                        <i slot="suffix" style="font-style:normal;margin: 5px;display: inline-block;">%</i>
                      </el-input>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="
              " label="成交额" width="260px" v-if="typeGrade == '10'">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.upgradeConditions" size="small"></el-input>
                </template>
              </el-table-column> -->
                  <el-table-column prop="upgradeConditions" label="成交金额（元）" width="260px">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.upgradeConditions" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="peerLevelRate" label="平级奖（%）">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.peerLevelRate" size="small">
                        <i slot="suffix" style="font-style:normal;margin: 5px;display: inline-block;">%</i>
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.remark" size="small"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>

            <div style="text-align: center;position:fixed;bottom: 50px;left:53%;">
              <el-button type="primary" size="small" @click="handleClick('save2')">保存</el-button>
            </div>
            <!-- 添加等级 -->
            <el-dialog title="添加等级" :visible.sync="diaLogVisibleAddGrade" width="30%">
              <el-form ref="formGrade" :model="formGrade" label-width="80px">
                <el-form-item label="等级名称" prop="name">
                  <el-input v-model="formGrade.name" placeholder="请输入等级名称" size="small"></el-input>
                </el-form-item>
                <el-form-item label="等级权重" prop="name">
                  <el-input v-model="formGrade.name" placeholder="请输入等级权重" size="small"></el-input>
                </el-form-item>
                <el-form-item>
                  <div style="color:#ccc">权重越大，等级越高</div>
                </el-form-item>
                <el-form-item label="一级上调" prop="name">
                  <el-input-number v-model="num" controls-position="right" size="small" :min="1" :max="10"></el-input-number>
                </el-form-item>
                <el-form-item>
                  <div style="color:#ccc">在默认分佣比列上上调如果原来是5%，这里上调3%，那么一级拿8%佣金</div>
                </el-form-item>
                <el-form-item label="自动升级">
                  <el-radio-group v-model="radio">
                    <el-radio :label="3">允许自动升级</el-radio>
                    <el-radio :label="6">禁止自动升级</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="升级条件">
                  <el-radio-group v-model="radio">
                    <el-radio :label="3">满足以下所有条件</el-radio>
                    <el-radio :label="6">满足以下任意条件</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="checked">累计佣金</el-checkbox>
                  <el-input disabled style="width: 213px;"></el-input>元
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="checked">直推分销商</el-checkbox>
                  <el-input disabled style="width: 213px;"></el-input>元
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handleClick('addGradeClose')" size="small">取 消</el-button>
                <el-button type="primary" @click="handleClick('addGradeConfim')" size="small">确 定</el-button>
              </span>
            </el-dialog>

            <!-- 等级编辑 -->
            <el-dialog title="等级编辑" :visible.sync="diaLogVisibleView">
              <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="等级名称" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handleClick('viewClose')" size="small">取 消</el-button>
                <el-button type="primary" @click="handleClick('viewConfim')" size="small">确 定</el-button>
              </span>
            </el-dialog>
          </el-tab-pane>

          <el-tab-pane label="云宝wifi等级设置" name="4">
            <el-table border :data="list_wifi" :loading="loading">
              <el-table-column prop="id" label="等级ID">
              </el-table-column>
              <el-table-column prop="name" label="等级名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="commissionRate" label="佣金比例（%）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.commissionRate" size="small">
                    <i slot="suffix" style="font-style:normal;margin: 5px;display: inline-block;">%</i>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="orderNum" label="成交单">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.orderNum" size="small">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" size="small"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;position:fixed;bottom: 50px;left:53%;">
              <el-button type="primary" size="small" @click="handleClick('wifiSave')">保存</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="升级日志" name="3">
            <el-table :data="tableLog" border>
              <el-table-column prop="userId" label="用户ID"></el-table-column>
              <el-table-column prop="name" label="分销员"></el-table-column>
              <el-table-column prop="oldName" label="原等级"></el-table-column>
              <el-table-column prop="newName" label="新等级"></el-table-column>
              <el-table-column prop="changeType" label="升级方式">
                <template slot-scope="scope">
                  {{ scope.row.changeType == 10 ? '后台管理员设置' : '自动升级' }}
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="升级时间"></el-table-column>
            </el-table>
            <div style="margin-top: 20px;">
              <el-pagination @size-change="handleSizeChange4" @current-change="handleCurrentChange4" :current-page="queryInfo4.pagenum"
                :page-sizes="[1, 5, 10, 20]" :page-size="queryInfo4.pagesize" layout="total, sizes, prev, pager, next, jumper"
                :total="queryInfo4.total">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>

      <el-tab-pane label="分销订单" name="3">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="佣金结算">
            <el-select size="small" v-model="formOrder.isLevel">
              <el-option v-for="item in isLevelOption" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="用户ID">
            <el-input v-model="formOrder.userId" style="width: 213px;" placeholder="请输入用户" size="small"></el-input>
            <el-button type="primary" size="small" style="margin-left:10px;" @click="queryOrder">查询</el-button>
            <el-button type="success" size="small"><i class="el-icon-plus"></i>导出</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-table :data="tableDataAgentOrder" border>
            <el-table-column prop="orderProducts" label="商品信息" width="600px">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.orderProducts[0].productName }}
                </div>
                <div>
                  {{ scope.row.orderProducts[0].productAttr }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="分销商" width="500px"></el-table-column>
            <el-table-column prop="orderProducts" label="单价/数量">
              <template slot-scope="scope">
                {{ scope.row.orderProducts[0].productPrice }}
              </template>
            </el-table-column>
            <el-table-column prop="orderProducts" label="实付款">
              <template slot-scope="scope">
                {{ scope.row.orderProducts[0].totalPayPrice }}
              </template>
            </el-table-column>
            <el-table-column prop="nickName" label="买家"></el-table-column>
            <el-table-column prop="referrerName" label="交易状态">
              <template slot-scope="scope">
                <el-tag :type="scope.row.referrerName == 1 ? 'info' : 'success'">{{ scope.row.dataType == 1 ? '未结算' :
      '已结算'
                  }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="commission" label="佣金结算"></el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 20px;">
          <el-pagination @size-change="handleSizeChange5" @current-change="handleCurrentChange5" :current-page="queryInfo5.pagenum"
            :page-sizes="[1, 5, 10, 20]" :page-size="queryInfo5.pagesize" layout="total, sizes, prev, pager, next, jumper"
            :total="queryInfo5.total">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="提现申请" name="4">
        <el-form :inline="true" :model="formWithdrawal" class="demo-form-inline">
          <el-form-item label="审核状态">
            <el-select size="small" v-model="formWithdrawal.dataType" clearable>
              <el-option v-for="item in statusOptionData" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input v-model="formWithdrawal.userId" style="width: 213px;" placeholder="请输入用户" size="small"></el-input>
            <el-input v-model="formWithdrawal.name" style="width: 213px;" placeholder="请输入昵称/姓名/手机号" size="small"></el-input>
            <el-button type="primary" size="small" style="margin-left:10px;" @click="queryWithdrawal">查询</el-button>
            <el-button type="success" size="small"><i class="el-icon-plus"></i>导出</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-top: 15px;">
          <el-table :data="tableWithdrawal" border>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
            <el-table-column prop="bankName" label="提现银行"></el-table-column>
            <el-table-column prop="name" label="用户姓名"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="avatarUrl" label="头像">
              <template slot-scope="scope">
                <img :src="scope.row.avatarurl" width="140px" v-if="scope.row.avatarurl" />
                <span v-if="scope.row.avatarurl == null || scope.row.avatarurl == '' || scope.row.avatarurl == undefined">
                  {{ '暂无图片' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="cardNumber" label="银行卡卡号"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="startDate" label="起始日期"></el-table-column>
            <el-table-column prop="endDate" label="结束日期"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status == 0 ? 'info' : scope.row.status == 1 ? 'success' : 'danger'">{{
      scope.row.status == 0 ? '待审核' : scope.row.status == 1 ? '审核通过' : '审核不通过' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="reason" label="不通过原因"></el-table-column>
            <!-- <el-table-column  label="操作" width="120">

            </el-table-column> -->
          </el-table>
          <div style="margin-top: 20px;">
            <el-pagination @size-change="handleSizeChange6" @current-change="handleCurrentChange6" :current-page="queryInfo6.pagenum"
              :page-sizes="[1, 5, 10, 20]" :page-size="queryInfo6.pagesize" layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo6.total">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="分销设置" name="5">
        <el-tabs v-model="activeName3" type="card" @tab-click="tabChange">
          <el-tab-pane label="1.0" name="1">
            <el-form :model="setFormOne" label-width="180px">
              <div style="display:flex">
                <el-form-item label="销售利润类型：">
                  <el-select v-model="setFormOne.retailMarginType" size="small" clearable>
                    <el-option v-for="item in retailMarginType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="销售利润：">
                  <el-input v-model="setFormOne.retailMargin" placeholder="请输入销售利润" clearable style="width: 300px;"
                    size="small"></el-input>
                  <p v-if="setFormOne.retailMargin == 0">%</p>
                </el-form-item>
              </div>
              <el-form-item label="伯乐奖分享人数：">
                <el-input v-model="setFormOne.boleAward.sharesNumber" placeholder="请输入分享人数" clearable style="width: 300px;"
                  size="small"></el-input>
              </el-form-item>
              <el-form-item label="伯乐奖收入比例：">
                <el-input v-model="setFormOne.boleAward.proportion" placeholder="请输入收入比例" clearable style="width: 300px;"
                  size="small"></el-input>
              </el-form-item>
              <el-form-item label="伯乐奖赠送优惠券">
                <el-select v-model="setFormOne.boleAward.coupon" size="small" clearable style="width: 300px;">
                  <el-option v-for="item in couponList" :key="item.couponId" :label="item.name" :value="item.couponId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="全国市场分红类型：">
                <el-select v-model="setFormOne.NationalDividendAward.type" size="small" clearable style="width: 300px;">
                  <el-option v-for="item in typeGradeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <div>
                  <el-input v-model="setFormOne.NationalDividendAward.number" :placeholder="setFormOne.NationalDividendAward.type == '10' ? '请输入金额（元）' : setFormOne.NationalDividendAward.type == '20' ? '请输入订单数' : '请输入'"
                    clearable style="width: 300px;" size="small"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="全国市场收入比例：">
                <el-input v-model="setFormOne.NationalDividendAward.proportion" placeholder="请输入收入比例" clearable style="width: 300px;"
                  size="small"></el-input>
              </el-form-item>
              <!--<el-form-item label="激活奖：">
                首刷&nbsp;&nbsp;&nbsp;<el-input v-model="setFormOne.activation.number" class="inp"
                  size="small"></el-input>&nbsp;&nbsp;&nbsp;返&nbsp;&nbsp;&nbsp;<el-input class="inp" size="small"
                  v-model="setFormOne.activation.back"></el-input><i class="el-icon-plus"></i><el-input class="inp" size="small"
                  v-model="setFormOne.activation.exchange"></el-input>
              </el-form-item>
              <el-form-item label="达标奖：">
                次月刷&nbsp;&nbsp;&nbsp;<el-input v-model="setFormOne.compliance.number" size="small"
                  class="inp"></el-input>&nbsp;&nbsp;&nbsp;返&nbsp;&nbsp;&nbsp;<el-input size="small" class="inp"
                  v-model="setFormOne.compliance.back"></el-input>
              </el-form-item>
              <el-form-item label="冻结奖：">
                <el-input v-model="setFormOne.freeze" size="small" class="inp"></el-input>&nbsp;&nbsp;&nbsp;返代理
              </el-form-item>-->
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="2.0" name="2">
            <el-form :model="setForm" label-width="180px">
              <div style="display:flex">
                <el-form-item label="销售利润类型：">
                  <el-select v-model="setForm.retailMarginType" size="small" clearable>
                    <el-option v-for="item in retailMarginType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="销售利润：">
                  <el-input v-model="setForm.retailMargin" placeholder="请输入销售利润" clearable style="width: 300px;" size="small"></el-input>
                  <p v-if="setForm.retailMargin == 0">%</p>
                </el-form-item>
              </div>
              <el-form-item label="伯乐奖分享人数：">
                <el-input v-model="setForm.boleAward.sharesNumber" placeholder="请输入分享人数" clearable style="width: 300px;"
                  size="small"></el-input>
              </el-form-item>
              <el-form-item label="伯乐奖收入比例：">
                <el-input v-model="setForm.boleAward.proportion" placeholder="请输入收入比例" clearable style="width: 300px;"
                  size="small"></el-input>
              </el-form-item>
              <el-form-item label="伯乐奖赠送优惠券">
                <el-select v-model="setForm.boleAward.coupon" size="small" clearable style="width: 300px;">
                  <el-option v-for="item in couponList" :key="item.couponId" :label="item.name" :value="item.couponId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="全国市场分红类型：">
                <el-select v-model="setForm.NationalDividendAward.type" size="small" clearable style="width: 300px;">
                  <el-option v-for="item in typeGradeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <div>
                  <el-input v-model="setForm.NationalDividendAward.number" :placeholder="setForm.NationalDividendAward.type == '10' ? '请输入金额（元）' : setForm.NationalDividendAward.type == '20' ? '请输入订单数' : '请输入'"
                    clearable style="width: 300px;" size="small"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="全国市场收入比例：">
                <el-input v-model="setForm.NationalDividendAward.proportion" placeholder="请输入收入比例" clearable style="width: 300px;"
                  size="small"></el-input>
              </el-form-item>
              <!--<el-form-item label="激活奖：">
                首刷&nbsp;&nbsp;&nbsp;<el-input v-model="setForm.activation.number" class="inp"
                  size="small"></el-input>&nbsp;&nbsp;&nbsp;返&nbsp;&nbsp;&nbsp;<el-input class="inp" size="small"
                  v-model="setForm.activation.back"></el-input><i class="el-icon-plus"></i><el-input class="inp" size="small"
                  v-model="setForm.activation.exchange"></el-input>
              </el-form-item>
              <el-form-item label="达标奖：">
                次月刷&nbsp;&nbsp;&nbsp;<el-input v-model="setForm.compliance.number" size="small"
                  class="inp"></el-input>&nbsp;&nbsp;&nbsp;返&nbsp;&nbsp;&nbsp;<el-input size="small" class="inp"
                  v-model="setForm.compliance.back"></el-input>
              </el-form-item>
              <el-form-item label="冻结奖：">
                <el-input v-model="setForm.freeze" size="small" class="inp"></el-input>&nbsp;&nbsp;&nbsp;返代理
              </el-form-item>-->
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="激活数量设置" name="3">
            <el-form :mode="activationForm" label-width="180px">
              <el-form-item label="中付：">
                <el-input v-model="activationForm.zf" placeholder="请输入" clearable style="width: 300px;" size="small"></el-input>
              </el-form-item>
              <el-form-item label="和融通：">
                <el-input v-model="activationForm.hrt" placeholder="请输入" clearable style="width: 300px;" size="small"></el-input>
              </el-form-item>
              <el-form-item label="合利宝：">
                <el-input v-model="activationForm.hlb" placeholder="请输入" clearable style="width: 300px;" size="small"></el-input>
              </el-form-item>
              <el-form-item label="电银：">
                <el-input v-model="activationForm.dy" placeholder="请输入" clearable style="width: 300px;" size="small"></el-input>
              </el-form-item>
              <el-form-item label="联动支付：">
                <el-input v-model="activationForm.ldzf" placeholder="请输入" clearable style="width: 300px;" size="small"></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="旅游券发放设置" name="4">
            <el-form :mode="activationForm2" label-width="180px">
              <div class="activationForm2" style="display:flex">
                买
                <el-form-item>
                  <el-input v-model="activationForm2.deviceNum" placeholder="请输入" clearable style="width: 100px;" size="small"></el-input>
                </el-form-item>
                台机器，返
                <el-form-item>
                  <el-select v-model="activationForm2.couponId" size="small" clearable style="width: 150px;">
                    <el-option v-for="item in couponList" :key="item.couponId" :label="item.name" :value="item.couponId"></el-option>
                  </el-select>
                </el-form-item>
                券
              </div>

            </el-form>
          </el-tab-pane>
          <el-tab-pane label="股东分红设置" name="5">
            <el-table :data="shareholder" border style="width:600px;margin:0 auto;">
              <el-table-column prop="money" label="金额">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.money" @input="handleInput(scope.$index)">
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="proportion" label="百分比">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.proportion" @input="handleInput2(scope.$index)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="delTable(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button size="small" style="width:600px;margin:0 auto 50px;display:block;" @click="addTable()">新增设置</el-button>
          </el-tab-pane>
          <el-tab-pane label="周期奖励设置" name="6">
            <el-table :data="activeNum" border style="width:800px;margin:0 auto;">
              <el-table-column type="index" label="序号" width="50">
              </el-table-column>
              <el-table-column prop="startDay" label="采购之日起开始时间天数">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.startDay" @input="handleInput3(scope.$index,'startDay')">
                    <template slot="append">天</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="endDay" label="采购之日起结束时间天数">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.endDay" @input="handleInput3(scope.$index,'endDay')">
                    <template slot="append">天</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="激活机器数量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" @input="handleInput3(scope.$index,'num')">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="transactionAmount" label="交易金额">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.transactionAmount" @input="handleInput3(scope.$index,'transactionAmount')">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="back" label="返佣多少钱">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.back" @input="handleInput4(scope.$index)">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="delTable2(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button size="small" style="width:800px;margin:0 auto 50px;display:block;" @click="addTable2()">新增设置</el-button>
          </el-tab-pane>
          <div class="footer-btn" style="display:flex;justify-content:center;margin-bottom: 40px;">
            <el-button type="primary" size="small" @click="KeepSetting">保存</el-button>
          </div>

        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import distributionApi from '@/api/plus/distribution.js';
  import Distribution from '@/api/distribution.js';
  import CouponApi from '@/api/coupon.js';
  export default {
    data() {
      return {
        retailMarginType: [{
            name: '按比例',
            value: 0
          },
          {
            name: '按台',
            value: 1
          }
        ],
        setForm: {
          retailMarginType: '',
          retailMargin: '', //零售利润
          boleAward: { //伯乐奖
            sharesNumber: '', //分享人数
            proportion: '' //收入比例
          },
          NationalDividendAward: { //全国市场分红
            type: '', //类型（10:按订单、20:按金额）
            number: '', // 金额 万元或订单数
            proportion: ''
          },
          activation: { //激活奖
            number: '', //激活之后一个月内刷多少元
            back: '', //返多少元
            exchange: '' //返多少张兑换卷
          },
          compliance: { //达标奖
            number: '', //次月刷多少元
            back: '' //返多少元
          },
          freeze: '' //冻结奖 单位元
        },
        setFormOne: {
          retailMarginType: '',
          retailMargin: '', //零售利润
          boleAward: { //伯乐奖
            sharesNumber: '', //分享人数
            proportion: '' //收入比例
          },
          NationalDividendAward: { //全国市场分红
            type: '', //类型（10:按订单、20:按金额）
            number: '', // 金额 万元或订单数
            proportion: ''
          },
          activation: { //激活奖
            number: '', //激活之后一个月内刷多少元
            back: '', //返多少元
            exchange: '' //返多少张兑换卷
          },
          compliance: { //达标奖
            number: '', //次月刷多少元
            back: '' //返多少元
          },
          freeze: '' //冻结奖 单位元
        },
        level: '1',
        diaLogVisibleSubordinate: false,
        formRules: {
          referrerId: [{
            required: true,
            message: "请输入推荐人ID",
            trigger: "blur"
          }]
        },
        formOrder: {
          isLevel: 0
        },
        formWithdrawal: {},
        statusOptionData: [{
            label: '待审核',
            value: 'audit'
          },
          {
            label: '审核通过',
            value: 'pass'
          },
          {
            label: '审核不通过',
            value: 'noPass'
          },
        ],
        isLevelOption: [{
            label: '全部',
            value: 0
          },
          {
            label: '已结算',
            value: 2
          },
          {
            label: '未结算',
            value: 1
          },
        ],
        statusOption: [{
            label: '全部',
            value: '1'
          },
          {
            label: '待审核',
            value: '2'
          },
          {
            label: '审核通过',
            value: '3'
          },
          {
            label: '已打款',
            value: '4'
          },
          {
            label: '驳回',
            value: '5'
          },
        ],
        paymentOption: [{
            label: '全部',
            value: '1'
          },
          {
            label: '微信',
            value: '2'
          },
          {
            label: '支付宝',
            value: '3'
          },
          {
            label: '银行卡',
            value: '4'
          },
        ],
        tableLog: [],
        activeName2: '1',
        activeName3: '1',
        queryInfo: {
          total: 0,
          pagenum: 1,
          pagesize: 10,
        },
        queryInfo2: {
          total: 0,
          pagenum: 1,
          pagesize: 10,
        },
        queryInfo3: {
          total: 0,
          pagenum: 1,
          pagesize: 10,
        },
        queryInfo4: {
          total: 0,
          pagenum: 1,
          pagesize: 10,
        },
        queryInfo5: {
          total: 0,
          pagenum: 1,
          pagesize: 10,
        },
        queryInfo6: {
          total: 0,
          pagenum: 1,
          pagesize: 10,
        },
        activeName: '1',
        activeName4: '1',
        tableData: [],
        shareholder: [],
        activeNum: [],
        diaLogVisibleAdd: false,
        diaLogVisibleSelect: false,
        diaLogVisibleView: false,
        diaLogVisibleAddGrade: false,
        form: {},
        multipleSelection: [],
        formInline: {},
        tableGeadeData: [],
        userTable: [],
        formGrade: {},
        loading: false,
        agentGradeIdOption: [],
        typeGrade: '10',
        typeGradeOption: [{
            value: '10',
            label: '成交单'
          },
          {
            value: '20',
            label: '成交额'
          },
        ],
        radio: null,
        input: null,
        value: null,
        formData: {},
        nameMoile: '',
        tableDataAgentOrder: [],
        userIds: null,
        tableWithdrawal: [],
        checked: '',
        num: 0,
        diaLogVisibleModify: false,
        list_planB: [],
        list_wifi: [],
        couponList: [],
        activationForm: {
          zf: 0,
          hrt: 0,
          hlb: 0,
          dy: 0,
          ldzf: 0
        },
        activationForm2: {
          deviceNum: null,
          couponId: null
        },
        settingType: 0,
      }
    },
    created() {
      this.getGradeList()
      this.getAgentList()
      this.getAgentGradeLog()
      this.getAgentOrder()
      this.getWithdrawalList()
      this.getSettingOneData()
      this.getSettingData()
      this.getCouponList()
      this.listWifi()
      // this.getActiveSetting()
      // this.getActiveSetting2()

    },
    methods: {
      getActiveSetting() {
        Distribution.getSettingActive({}).then((res) => {
          if (res.errCode === 200) {
            if (res.data) {
              this.activationForm = res.data

            }
          }
        })
      },
      getActiveSetting2() {
        Distribution.getSettingTravelCoupon({}).then((res) => {
          if (res.errCode === 200) {
            if (res.data) {
              this.activationForm2 = res.data

            }
          }
        })
      },
      getCouponList() {
        CouponApi.couponAll(true)
          .then(res => {
            this.couponList = res.data
          })
          .catch(error => {});
      },
      listPlanB() {
        console.log('qwewqewqewq')
        console.log(this.activeName4)
        distributionApi.getListPlanB({
          version: parseInt(this.activeName4)
        }).then(res => {
          console.log('B套餐表格数据', res)
          this.list_planB = res.data;
        }).catch(err => {
          console.log(err)
        })
      },
      listWifi() {
        distributionApi.getWifiGrade().then(res => {
          this.list_wifi = res.data;
        }).catch(err => {
          console.log(err)
        })
      },
      // 切换Tab
      cutTab(tab) {
        console.log('当前选中的 tab', this.activeName);
        console.log('切换后的 tab', tab.name);

        if (tab.name == 5) {
          distributionApi.getSetting({}).then(res => {
            console.log(res)
          }).catch(err => {
            console.log(err)
          })
        }
      },
      tabChange(tab) {
        console.log(tab)
        this.settingType = parseInt(tab.index)
        if (tab.index === '0') {
          this.getSettingOneData()
        }
        if (tab.index === '1') {
          this.getSettingData()
        }
        if (tab.index === '2') {
          this.getActiveSetting()
        }
        if (tab.index === '3') {
          this.getActiveSetting2()
        }
        if (tab.index === '4') {
          distributionApi.getShareholder().then(res => {
            console.log(res)
            this.shareholder = res.data.shareholder
          }).catch(err => {
            console.log(err)
          })
        }
        if (tab.index === '5') {
          distributionApi.getActiveNumBack().then(res => {
            console.log(res)
            this.activeNum = res.data.activeNum
          }).catch(err => {
            console.log(err)
          })
        }
      },
      // 保存分销商设置
      KeepSetting() {
        let params = {}
        if (this.settingType === 1) {
          params = {

            retailMarginType: this.setForm.retailMarginType, //零售利润类型
            retailMargin: this.setForm.retailMargin, //零售利润
            boleAward: { //伯乐奖
              sharesNumber: this.setForm.boleAward.sharesNumber, //分享人数
              proportion: this.setForm.boleAward.proportion, //收入比例
              coupon: this.setForm.boleAward.coupon
            },
            NationalDividendAward: { //全国市场分红
              type: this.setForm.NationalDividendAward.type, //类型（10:按订单、20:按金额）
              number: this.setForm.NationalDividendAward.number, // 金额 万元或订单数
              proportion: this.setForm.NationalDividendAward.proportion
            },
            activation: { //激活奖
              number: this.setForm.activation.number, //激活之后一个月内刷多少元
              back: this.setForm.activation.back, //返多少元
              exchange: this.setForm.activation.exchange //返多少张兑换卷
            },
            compliance: { //达标奖
              number: this.setForm.compliance.number, //次月刷多少元
              back: this.setForm.compliance.back //返多少元
            },
            freeze: this.setForm.freeze //冻结奖 单位元
          }
          distributionApi.getSettingdistribution({
            ...params
          }).then(res => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }).catch(err => {
            console.lg(err)
          })
        }
        if (this.settingType === 0) {
          params = {

            retailMarginType: this.setFormOne.retailMarginType, //零售利润类型
            retailMargin: this.setFormOne.retailMargin, //零售利润
            boleAward: { //伯乐奖
              sharesNumber: this.setFormOne.boleAward.sharesNumber, //分享人数
              proportion: this.setFormOne.boleAward.proportion, //收入比例
              coupon: this.setFormOne.boleAward.coupon
            },
            NationalDividendAward: { //全国市场分红
              type: this.setFormOne.NationalDividendAward.type, //类型（10:按订单、20:按金额）
              number: this.setFormOne.NationalDividendAward.number, // 金额 万元或订单数
              proportion: this.setFormOne.NationalDividendAward.proportion
            },
            activation: { //激活奖
              number: this.setFormOne.activation.number, //激活之后一个月内刷多少元
              back: this.setFormOne.activation.back, //返多少元
              exchange: this.setFormOne.activation.exchange //返多少张兑换卷
            },
            compliance: { //达标奖
              number: this.setFormOne.compliance.number, //次月刷多少元
              back: this.setFormOne.compliance.back //返多少元
            },
            freeze: this.setFormOne.freeze //冻结奖 单位元
          }
          distributionApi.getSettingOnedistribution({
            ...params
          }).then(res => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }).catch(err => {
            console.lg(err)
          })
        }
        if (this.settingType === 2) {
          this.KeepActiveSetting()
        }
        if (this.settingType === 3) {
          this.KeepActiveSetting2()
        }
        if (this.settingType === 4) {
          let istrue = true
          if (!this.shareholder.length) {
            this.$message({
              message: '请至少添加一行设置项',
              type: 'warning'
            });
            return false
          }
          this.shareholder.forEach((item) => {
            if (!item.money || !item.proportion) {
              istrue = false
            }
          })
          if (!istrue) {
            this.$message({
              message: '请将表格填写完整',
              type: 'warning'
            });
            return false
          }
          console.log(this.shareholder)
          distributionApi.saveShareholder({
            shareholder: this.shareholder
          }).then(res => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }).catch(err => {
            console.lg(err)
          })
        }
        if (this.settingType === 5) {
          let istrue = true
          if (!this.activeNum.length) {
            this.$message({
              message: '请至少添加一行设置项',
              type: 'warning'
            });
            return false
          }
          this.activeNum.forEach((item, index) => {
            item.Number = index + 1
            if (!item.startDay || !item.endDay || !item.num || !item.transactionAmount || !item.back) {
              istrue = false
            }
          })
          if (!istrue) {
            this.$message({
              message: '请将表格填写完整',
              type: 'warning'
            });
            return false
          }
          distributionApi.saveActiveNumBack({
            activeNum: this.activeNum
          }).then(res => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }).catch(err => {
            console.lg(err)
          })
        }
      },

      delTable(index) {
        this.shareholder.splice(index, 1)
      },
      addTable() {
        this.shareholder.push({
          money: '',
          proportion: ''
        })
      },
      delTable2(index) {
        this.activeNum.splice(index, 1)
      },
      addTable2() {
        this.activeNum.push({
          startDay: '',
          endDay: '',
          num: '',
          transactionAmount: '',
          back: ''
        })
      },

      handleInput(index) {
        // 只允许输入数字和小数点，保留两位小数
        this.shareholder[index].money = this.shareholder[index].money.replace(/[^\d.]/g, ''); // 只保留数字和小数点
        this.shareholder[index].money = this.shareholder[index].money.replace(/^\./g, ''); // 第一个字符不是小数点
        this.shareholder[index].money = this.shareholder[index].money.replace(/\.{2,}/g, '.'); // 不允许多个小数点
        this.shareholder[index].money = this.shareholder[index].money.replace('.', '$#$').replace(/\./g, '').replace(
          '$#$', '.'); // 只保留一个小数点
        this.shareholder[index].money = this.shareholder[index].money.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只保留两位小数
      },

      handleInput2(index) {
        // 只允许输入数字和小数点，保留两位小数，且不带 %
        this.shareholder[index].proportion = this.shareholder[index].proportion.replace(/[^\d.]/g, ''); // 只保留数字和小数点
        this.shareholder[index].proportion = this.shareholder[index].proportion.replace(/^\./g, ''); // 第一个字符不是小数点
        this.shareholder[index].proportion = this.shareholder[index].proportion.replace(/\.{2,}/g, '.'); // 不允许多个小数点
        this.shareholder[index].proportion = this.shareholder[index].proportion.replace('.', '$#$').replace(/\./g, '').replace(
          '$#$', '.'); // 只保留一个小数点
        this.shareholder[index].proportion = this.shareholder[index].proportion.replace(/^(\-)*(\d+)\.(\d\d).*$/,
          '$1$2.$3'); // 只保留两位小数
        if (this.shareholder[index].proportion !== '' && Number(this.shareholder[index].proportion) > 100) {
          this.shareholder[index].proportion = '100'; // 如果输入的百分比大于100，则设置为100
        }
      },

      handleInput3(index, name) {
        this.activeNum[index][name] = this.activeNum[index][name].replace(/[^\d]/g, '')
      },

      handleInput4(index) {
        // 只允许输入数字和小数点，保留两位小数
        this.activeNum[index].money = this.activeNum[index].money.replace(/[^\d.]/g, ''); // 只保留数字和小数点
        this.activeNum[index].money = this.activeNum[index].money.replace(/^\./g, ''); // 第一个字符不是小数点
        this.activeNum[index].money = this.activeNum[index].money.replace(/\.{2,}/g, '.'); // 不允许多个小数点
        this.activeNum[index].money = this.activeNum[index].money.replace('.', '$#$').replace(/\./g, '').replace('$#$',
          '.'); // 只保留一个小数点
        this.activeNum[index].money = this.activeNum[index].money.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只保留两位小数
      },


      //保存激活数量设置
      KeepActiveSetting() {
        let params = {
          zf: this.activationForm.zf || 0,
          hrt: this.activationForm.hrt || 0,
          hlb: this.activationForm.hlb || 0,
          dy: this.activationForm.dy || 0,
          ldzf: this.activationForm.ldzf || 0
        }
        distributionApi.settingActive({
          ...params
        }).then((res) => {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        })
      },
      KeepActiveSetting2() {
        if (!this.activationForm2.deviceNum) {
          this.$message({
            message: '请输入机器数',
            type: 'success'
          });
          return
        }
        if (!this.activationForm2.couponId) {
          this.$message({
            message: '请选择卡券',
            type: 'success'
          });
          return
        }
        distributionApi.settingTravelCoupon({
          ...this.activationForm2
        }).then((res) => {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        })
      },
      getSettingOneData() {
        Distribution.getSettingOne({

        }).then(res => {
          if (res.errCode == 200) {
            if (res.data) {
              this.setFormOne = res.data
            }
          }
        })
      },
      getSettingData() {
        Distribution.getSetting({

        }).then(res => {
          if (res.errCode == 200) {

            this.setForm = res.data
          }
        })
      },

      queryWithdrawal() {
        this.getWithdrawalList()
      },
      queryOrder() {
        this.getAgentOrder()
      },
      // 提现申请列表
      getWithdrawalList() {
        Distribution.getWithdrawal({
          dataType: this.formWithdrawal.dataType,
          userId: this.formWithdrawal.userId,
          name: this.formWithdrawal.name,
          pageIndex: this.queryInfo6.pagenum,
          pageSize: this.queryInfo6.pagesize
        }).then(res => {
          if (res.errCode == 200) {

            this.queryInfo6.total = res.data.orderList.total
            this.tableWithdrawal = res.data.orderList.records
          }
        })
      },

      // 分销订单接口
      getAgentOrder() {
        let self = this;
        Distribution.getAgentOrder({
            userId: this.formOrder.userId,
            isLevel: this.formOrder.isLevel,
            pageIndex: this.queryInfo5.pagenum,
            pageSize: this.queryInfo5.pagesize
          }, true)
          .then(res => {
            this.queryInfo5.total = res.data.total
            self.loading = false;
            self.tableDataAgentOrder = res.data.records;
          })
          .catch(error => {});
      },
      // 升级列表接口
      getAgentGradeLog() {
        let self = this;
        Distribution.getAgentGradeLog({
            pageIndex: this.queryInfo4.pagenum,
            pageSize: this.queryInfo4.pagesize
          }, true)
          .then(res => {
            this.queryInfo4.total = res.data.total
            self.loading = false;
            self.tableLog = res.data.records;
          })
          .catch(error => {});
      },
      // 获取分销商列表数据
      getAgentList() {
        let self = this;
        Distribution.agentList({
            name: this.nameMoile,
            mobile: '',
            pageIndex: this.queryInfo.pagenum,
            pageSize: this.queryInfo.pagesize
          }, true)
          .then(res => {
            this.queryInfo.total = res.data.total
            self.loading = false;
            self.tableData = res.data.records;
          })
          .catch(error => {});
      },
      handleSizeChange6(val) {
        this.queryInfo6.pagesize = val
        this.getWithdrawalList()
      },
      handleCurrentChange6(val) {
        this.queryInfo6.pagenum = val;
        this.getWithdrawalList()
      },
      //分销订单
      handleSizeChange5(val) {
        this.queryInfo5.pagesize = val
        this.getAgentOrder()
      },
      handleCurrentChange5(val) {
        this.queryInfo5.pagenum = val;
        this.getAgentOrder()
      },
      handleSizeChange4(val) {
        this.queryInfo4.pagesize = val
        this.getAgentGradeLog()
      },
      handleCurrentChange4(val) {
        this.queryInfo4.pagenum = val;
        this.getAgentGradeLog()
      },
      // 下级分销商列表分页
      handleSizeChange3(val) {
        this.queryInfo3.pagesize = val
        this.getLevelUserList()
      },
      handleCurrentChange3(val) {
        this.queryInfo3.pagenum = val;
        this.getLevelUserList()
      },
      // 分销商列表分页
      handleSizeChange(val) {
        this.queryInfo.pagesize = val
        this.getAgentList()
      },
      handleCurrentChange(val) {
        this.queryInfo.pagenum = val;
        this.getAgentList()
      },
      handleSelectionChange(val) {
        if (val.length > 1) {
          this.$refs.accountRef.clearSelection(); //清除
          this.$refs.accountRef.toggleRowSelection(val.pop()); //pop：最后一个
        } else {
          this.multipleSelection = val;
        }
      },
      /*获取套餐A列表数据*/
      getGradeList() {
        let self = this;
        Distribution.getList({}, true)
          .then(res => {
            self.loading = false;

            console.log(JSON.parse(res.data[0].upgradeConditions));
            self.tableGeadeData = res.data.map(item => {
              return {
                gradeId: item.gradeId,
                name: item.name,
                commissionRate: item.commissionRate,
                upgradeConditions: JSON.parse(item.upgradeConditions),
                people: JSON.parse(item.upgradeConditions).people || '',
                num: JSON.parse(item.upgradeConditions).num || '',
                // type:JSON.parse(item.upgradeCondition).type||null,
                peerLevelRate: item.peerLevelRate,
                remark: item.remark
              }
            })
            // self.tableGeadeData = res.data
            console.log(self.tableGeadeData);
            if (self.tableGeadeData.length) {
              this.typeGrade = self.tableGeadeData[0].upgradeConditions.type
            }
            // 等级下拉
            self.agentGradeIdOption = res.data;
          })
          .catch(error => {});
      },
      // 新增分销商选择会员列表数据分页
      handleSizeChange2(val) {
        this.queryInfo2.pagesize = val
        this.getUserList()
      },
      handleCurrentChange2(val) {
        this.queryInfo2.pagenum = val
        this.getUserList()
      },
      getUserList() {
        Distribution.getUserList({
            nickName: this.formInline.nickName,
            mobile: this.formInline.mobile,
            pageIndex: this.queryInfo2.pagenum,
            pageSize: this.queryInfo2.pagesize
          })
          .then(res => {
            if (res.errCode == 200) {
              this.userTable = res.data.records
              this.queryInfo2.total = res.data.total
            }
          })
          .catch(error => {});
      },
      handleClose(done) {
        this.form = {}
        done()
        this.diaLogVisibleAdd = false
      },
      inputProportion(value, name, index) {
        console.log(value)
        console.log(name)
        console.log(index)
        let str = ('' + value)
          .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d{0,2}(\.?\d{0,2})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，	而且小数点后面只能有0到2位小数
        console.log(str)
        if (Number(str)) {
          // 小于100大于0正确
          if (0 < Number(str) && Number(str) < 100) {
            console.log(1, str)
            this.tableGeadeData[index][name] = str
          } else {
            // 大于100直接将第三个删掉替换为前两个字符组。触发字符100.25等
            console.log(2, str)
            // this.zzbds = aa.splice(3,1)
            this.tableGeadeData[index][name] = str.replace(/(.{2})./g, "$1")
          }
        } else { // 不是个数，比如abd、0......等，原因是上面的判断覆盖了一部分正则校验
          if (str != '0.') {
            // 不是0.开头的，比如字母等直接替换为空。触发字符abds等
            this.tableGeadeData[index][name] = ''
            console.log('zm', str)
          } else {
            // 是0.开头的换为0.，触发字符0......等
            this.tableGeadeData[index][name] = str
            console.log('sm', str)
          }
        }

      },
      handleClick(action, row) {
        let self = this;
        switch (action) {
          case 'submit': // 选择用户查询
            this.getUserList()
            break
          case 'saveSet': // 分销设置
            Distribution.getSettingBody(this.setForm).then(res => {
              if (res.errCode == 200) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
              }
            })

            break
          case 'save': // 等级列表保存
            let arr = this.tableGeadeData.map(item => {
              return {
                gradeId: item.gradeId,
                name: item.name,
                commissionRate: item.commissionRate,
                upgradeCondition: {
                  "people": item.people || '',
                  "num": item.num || '',
                  "type": this.typeGrade || '',
                },
                peerLevelRate: item.peerLevelRate,
                remark: item.remark,
                plan: 1
              }
            })
            console.log(arr)
            let istrue = true
            arr.forEach((item) => {
              if (!item.name || !item.commissionRate || !item.peerLevelRate || !item.upgradeCondition.num || !item.upgradeCondition
                .people) {
                this.$message({
                  type: "waring",
                  message: '请填写完整信息'
                })
                istrue = false
                return false
              }
            })
            if (!istrue) {
              return false
            }
            console.log(arr)

            let param = {
              userAgentGrades: arr
            }
            Distribution.settingLevel(param)
              .then(res => {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.getGradeList()

              })
              .catch(error => {});
            break
          case 'save2': // 等级列表保存
            arr = this.list_planB.map(item => {
              return {
                gradeId: item.gradeId,
                name: item.name,
                commissionRate: item.commissionRate,
                peerLevelRate: item.peerLevelRate,
                remark: item.remark,
                upgradeConditions: item.upgradeConditions,
                plan: 2
              }
            })
            console.log(arr)
            istrue = true
            arr.forEach((item) => {
              if (!item.name || !item.commissionRate || !item.peerLevelRate) {
                this.$message({
                  type: "waring",
                  message: '请填写完整信息'
                })
                istrue = false
                return false
              }
            })
            if (!istrue) {
              return false
            }
            console.log(arr)

            param = {
              userAgentGrades: arr
            }
            Distribution.settingLevel(param)
              .then(res => {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.listPlanB()

              })
              .catch(error => {});
            break
          case 'wifiSave': // 等级列表保存
            param = {
              userGrades: this.list_wifi
            }
            distributionApi.saveWifiGrade(param)
              .then(res => {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.listWifi();
              })
              .catch(error => {});
            break;
          case 'view': // 等级编辑
            this.diaLogVisibleView = true
            break
          case 'viewClose': // 等级编辑取消
            this.diaLogVisibleView = false
            break
          case 'viewConfim': // 等级编辑添加
            this.diaLogVisibleView = false
            break
          case 'addGrade': // 添加等级
            this.diaLogVisibleAddGrade = true
            break
          case 'addGradeClose': // 添加等级取消
            this.diaLogVisibleAddGrade = false
            break
          case 'addGradeConfim': // 添加等级添加
            this.diaLogVisibleAddGrade = false
            break
          case 'selectVIP': // 选择会员
            this.diaLogVisibleSelect = true
            this.getUserList()
            break
          case 'closeVIP': // 选择会员取消
            this.diaLogVisibleSelect = false
            break
          case 'confimVIP': // 选择会员添加
            this.diaLogVisibleSelect = false
            if (this.multipleSelection.length > 0) {
              this.form.mobile = this.multipleSelection[0].mobile //手机号
              this.form.name = this.multipleSelection[0].nickname //姓名
              this.form.userId = this.multipleSelection[0].userId //用户ID
            }
            break
          case 'querySubmit': // 分销商列表查询
            this.getAgentList()

            break
          case 'add': // 添加
            this.diaLogVisibleAdd = true

            break
          case 'close': // 添加取消
            this.diaLogVisibleAdd = false
            this.form = {}
            break
          case 'confim': // 添加确定
            if (this.multipleSelection && this.multipleSelection.length > 0) {
              Distribution.agentListAdd(this.form)
                .then(res => {
                  if (res.errCode == 200) {

                    this.$message({
                      message: '添加成功',
                      type: 'success'
                    });
                    this.loading = false;
                    this.getAgentList()
                    this.form = {}
                  }

                })
                .catch(error => {});
            } else {
              return this.$message({
                message: '请选择会员',
                type: 'warning'
              })
            }
            this.diaLogVisibleAdd = false
            break
          case 'orderForGoods': // 订单
            let self = this;
            Distribution.getAgentOrder({
                userId: row.userId,
                isLevel: this.formOrder.isLevel,
                pageIndex: this.queryInfo5.pagenum,
                pageSize: this.queryInfo5.pagesize
              }, true)
              .then(res => {
                this.queryInfo5.total = res.data.total
                self.loading = false;
                self.tableDataAgentOrder = res.data.records;
              })
              .catch(error => {});
            this.activeName = '4'
            break
          case 'withdrawal': // 提现
            this.activeName = '5'
            Distribution.getWithdrawal({
              status: this.formWithdrawal.status,
              userId: row.userId,
              name: row.name,
              pageIndex: this.queryInfo6.pagenum,
              pageSize: this.queryInfo6.pagesize
            }).then(res => {
              if (res.errCode == 200) {

                this.queryInfo6.total = res.data.orderList.total
                this.tableWithdrawal = res.data.orderList.records
              }
            })
            break
          case 'subordinate': // 下级
            this.form.id = row.id
            this.getLevelUserList()
            break
          case 'modify': //修改
            this.diaLogVisibleModify = true
            this.form = row
            break
          case 'closeModify': //修改取消
            this.diaLogVisibleModify = false
            this.form = {}
            break
          case 'confimModify': //修改确定
            Distribution.agentListAdd(this.form)
              .then(res => {
                if (res.errCode == 200) {
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                  this.loading = false;
                  this.getAgentList()
                  this.form = {}
                  this.diaLogVisibleModify = false
                }

              })
              .catch(error => {});
            break
          case 'del': //删除
            Distribution.delAgentUser({
                id: row.id
              })
              .then(res => {
                if (res.errCode == 200) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.loading = false;
                  this.getAgentList()
                }

              })
              .catch(error => {});
            break
        }
      },
      getLevelUserList() {
        Distribution.getLevelUser({
            id: this.form.id,
            level: this.level
          })
          .then(res => {
            if (res.errCode == 200) {
              this.tableSubordinate = res.data.records
              self.loading = false;
              this.queryInfo3.total = res.data.total
              this.diaLogVisibleSubordinate = true
            }
          })
          .catch(error => {});
      },
      levelInput() {
        this.getLevelUserList()
      },
    },
    mounted() {
      this.listPlanB()
    }
  }
</script>
<style scoped>
  .el-icon-plus {
    margin: 0 10px;
  }

  .inp {
    width: 120px;
  }

  .titleBlue {
    font-weight: 600;
    border-left: 5px solid #3a8ee6;
    padding-left: 10px;
  }

  /deep/ .el-table__header-wrapper .el-checkbox {
    display: none;
  }

  .tip {
    font-size: 16px;
    font-weight: 600;
  }

  .activationForm2 {
    display: flex;
    align-items: center;
    margin: 5px 0;
  }

  /deep/ .activationForm2 .el-form-item__content {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }

  /deep/ .activationForm2 .el-form-item {
    margin-bottom: 0 !important;
  }

  .footer-btn {}
</style>



// WEBPACK FOOTER //
// src/views/plus/distribution/index.vue